import { defineMessages } from 'react-intl'

const scope = `modules.purchasing.features.listTermsAndMethods.termsMethodsTable`

export default defineMessages({
  tableAriaLabel: {
    id: `${scope}.tableAriaLabel`,
    defaultMessage: 'Terms and methods',
  },
  columnName: {
    id: `${scope}.columnName`,
    defaultMessage: 'Name',
  },
  columnDescription: {
    id: `${scope}.columnDescription`,
    defaultMessage: 'Description',
  },
  createdIndicator: {
    id: `${scope}.createdIndicator`,
    defaultMessage: 'Created',
  },
  updatedIndicator: {
    id: `${scope}.updatedIndicator`,
    defaultMessage: 'Updated',
  },
  emptyStateText: {
    id: `${scope}.emptyStateText`,
    defaultMessage: 'There are no items',
  },
  deleteItemButtonLabel: {
    id: `${scope}.deleteItemButtonLabel`,
    defaultMessage: 'Delete {name}',
  },
  deleteItemButtonTitle: {
    id: `${scope}.deleteItemButtonTitle`,
    defaultMessage: 'Delete',
  },
})
